// extracted by mini-css-extract-plugin
module.exports = {"root":"Toggle_root__H_bcP","thumb":"Toggle_thumb__6mKWE","label":"Toggle_label__FQD4J","container":"Toggle_container__Hmm6V"};